export const searchableContent = [
  // Salud y Bienestar
  {
    id: 'vitaminas-esenciales',
    category: 'salud',
    title: 'salud.vitaminas.title',
    content: 'salud.vitaminas.content',
    image:
      'https://images.pexels.com/photos/1153370/pexels-photo-1153370.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  },
  {
    id: 'minerales-clave',
    category: 'salud',
    title: 'salud.minerales.title',
    content: 'salud.minerales.content',
    image:
      'https://images.pexels.com/photos/5966439/pexels-photo-5966439.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  },
  {
    id: 'antioxidantes-omega3',
    category: 'salud',
    title: 'salud.antioxidantes.title',
    content: 'salud.antioxidantes.content',
    image:
      'https://images.pexels.com/photos/1640777/pexels-photo-1640777.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  },
  {
    id: 'proteina-colageno',
    category: 'salud',
    title: 'salud.proteina.title',
    content: 'salud.proteina.content',
    image:
      'https://images.pexels.com/photos/5946728/pexels-photo-5946728.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  },
  {
    id: 'probioticos-digestion',
    category: 'salud',
    title: 'salud.probioticos.title',
    content: 'salud.probioticos.content',
    image:
      'https://images.pexels.com/photos/5938360/pexels-photo-5938360.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  },

  // Deportes
  {
    id: 'fitness',
    category: 'deportes',
    title: 'deportes.fitness.title',
    content: 'deportes.fitness.content',
    image:
      'https://images.pexels.com/photos/1552242/pexels-photo-1552242.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  },
  {
    id: 'crossfit-hiit',
    category: 'deportes',
    title: 'deportes.crossfit.title',
    content: 'deportes.crossfit.content',
    image:
      'https://images.pexels.com/photos/4761663/pexels-photo-4761663.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  },
  {
    id: 'ciclismo-running',
    category: 'deportes',
    title: 'deportes.resistencia.title',
    content: 'deportes.resistencia.content',
    image:
      'https://images.unsplash.com/photo-1541625602330-2277a4c46182?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1740&q=80',
  },
  {
    id: 'deportes-equipo',
    category: 'deportes',
    title: 'deportes.equipo.title',
    content: 'deportes.equipo.content',
    image:
      'https://images.pexels.com/photos/47730/the-ball-stadion-football-the-pitch-47730.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  },
  {
    id: 'yoga-flexibilidad',
    category: 'deportes',
    title: 'deportes.yoga.title',
    content: 'deportes.yoga.content',
    image:
      'https://images.pexels.com/photos/4056535/pexels-photo-4056535.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  },
  {
    id: 'natacion-acuaticos',
    category: 'deportes',
    title: 'deportes.natacion.title',
    content: 'deportes.natacion.content',
    image:
      'https://images.pexels.com/photos/863988/pexels-photo-863988.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  },

  // Quema de Grasa
  {
    id: 'termogenicos',
    category: 'grasa',
    title: 'grasa.termogenicos.title',
    content: 'grasa.termogenicos.content',
    image:
      'https://images.pexels.com/photos/2294354/pexels-photo-2294354.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  },
  {
    id: 'control-apetito',
    category: 'grasa',
    title: 'grasa.apetito.title',
    content: 'grasa.apetito.content',
    image:
      'https://images.pexels.com/photos/1640770/pexels-photo-1640770.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  },
  {
    id: 'fundamentos-grasa',
    category: 'grasa',
    title: 'grasa.fundamentos.title',
    content: 'grasa.fundamentos.content',
    image:
      'https://images.pexels.com/photos/1109197/pexels-photo-1109197.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  },
  {
    id: 'metabolismo-energia',
    category: 'grasa',
    title: 'grasa.metabolismo-energetico.title',
    content: 'grasa.metabolismo-energetico.content',
    image:
      'https://images.pexels.com/photos/4056535/pexels-photo-4056535.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  },

  // Específico Mujer
  {
    id: 'fundamentos-mujer',
    category: 'mujer',
    title: 'mujer.fundamentos.title',
    content: 'mujer.fundamentos.content',
    image:
      'https://images.pexels.com/photos/5966431/pexels-photo-5966431.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  },
  {
    id: 'equilibrio-hormonal-piel',
    category: 'mujer',
    title: 'mujer.equilibrio.title',
    content: 'mujer.equilibrio.content',
    image:
      'https://images.pexels.com/photos/3764014/pexels-photo-3764014.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  },
  {
    id: 'escucha-cuerpo-mujer',
    category: 'mujer',
    title: 'mujer.escucha.title',
    content: 'mujer.escucha.content',
    image:
      'https://images.pexels.com/photos/4056535/pexels-photo-4056535.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  },
  {
    id: 'salud-osea-mujer',
    category: 'mujer',
    title: 'mujer.osea.title',
    content: 'mujer.osea.content',
    image:
      'https://images.pexels.com/photos/5946728/pexels-photo-5946728.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  },
  {
    id: 'belleza-natural-mujer',
    category: 'mujer',
    title: 'mujer.belleza.title',
    content: 'mujer.belleza.content',
    image:
      'https://images.pexels.com/photos/3764014/pexels-photo-3764014.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  },

  // Rendimiento Cognitivo
  {
    id: 'nootropicos-enfoque',
    category: 'cognitivo',
    title: 'cognitivo.nootropicos.title',
    content: 'cognitivo.nootropicos.content',
    image:
      'https://images.pexels.com/photos/7615458/pexels-photo-7615458.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  },
  {
    id: 'adaptogenos-estres',
    category: 'cognitivo',
    title: 'cognitivo.adaptogenos.title',
    content: 'cognitivo.adaptogenos.content',
    image:
      'https://images.pexels.com/photos/1051838/pexels-photo-1051838.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  },
  {
    id: 'salud-cerebral-largo-plazo',
    category: 'cognitivo',
    title: 'cognitivo.salud.title',
    content: 'cognitivo.salud.content',
    image:
      'https://images.pexels.com/photos/8981549/pexels-photo-8981549.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  },
  {
    id: 'estrategias-optimizacion-cognitivo',
    category: 'cognitivo',
    title: 'cognitivo.estrategias.title',
    content: 'cognitivo.estrategias.content',
    image:
      'https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  },
  {
    id: 'memoria-concentracion',
    category: 'cognitivo',
    title: 'cognitivo.memoria.title',
    content: 'cognitivo.memoria.content',
    image:
      'https://images.pexels.com/photos/7615458/pexels-photo-7615458.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  },
  {
    id: 'energia-mental-claridad',
    category: 'cognitivo',
    title: 'cognitivo.energia.title',
    content: 'cognitivo.energia.content',
    image:
      'https://images.pexels.com/photos/1051838/pexels-photo-1051838.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  },
];
